import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { EButtonTypes } from '../../../types';
import { ModalWrapperNew } from '../../atoms/ModalWrapper/ModalWrapper';
import { Delimiter } from '../../atoms/Delimiter';
const Wrapper = styled(ModalWrapperNew) `
  //padding: 40px;
  //min-width: 330px;
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;
const Img = styled.img `
  width: 374px;
  height: 207px;
`;
const Buttons = styled.div `
  display: flex;
  justify-content: space-between;
`;
export function MatchStart({ onStart, onSetOrder, onClose }) {
    return (_jsxs(Wrapper, { children: [_jsx(Delimiter, { top: "15px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0418\u043C\u043C\u0443\u043D\u0438\u0442\u0435\u0442\u044B \u043F\u0440\u0438\u0441\u0432\u043E\u0435\u043D\u044B?" })), _jsx(Delimiter, { top: "5px" }), _jsx(Button, Object.assign({ variant: "outlined", onClick: onClose, type: EButtonTypes.SUBMIT }, { children: "\u0418\u043C\u043C\u0443\u043D\u0438\u0442\u0435\u0442\u044B" })), _jsx(Delimiter, { top: "20px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u041F\u043E\u0440\u044F\u0434\u043E\u043A \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0437\u0430\u0434\u0430\u043D?" })), _jsx(Delimiter, { top: "5px" }), _jsx(Button, Object.assign({ variant: "outlined", onClick: onSetOrder, type: EButtonTypes.SUBMIT }, { children: "\u041F\u043E\u0440\u044F\u0434\u043E\u043A" })), _jsx(Delimiter, { top: "50px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: onStart, type: EButtonTypes.SUBMIT }, { children: "\u041D\u0430\u0447\u0438\u043D\u0430\u0435\u043C" })), _jsx(Delimiter, { top: "30px" })] }));
}
